import {
  Avatar,
  ChatContainer,
  MainContainer,
  Message,
  MessageInput,
  MessageList,
  TypingIndicator,
} from '@chatscope/chat-ui-kit-react';
import { Button, Grid, Stack, Typography, useMediaQuery } from '@mui/material';
import { variants } from '../../variants/variants';
import GGbotGIF from '../../assets/Gifs/bot.gif';
import { rocket } from '../Gift/assets/index';
import { useState } from 'react';
import { createMessage } from '../Gift/utility/createMessage';
import { useTheme } from '@emotion/react';

const GGBotChat = () => {
  const theme = useTheme()
  const isSm = useMediaQuery(theme.breakpoints.down("sm"))
  const [isStarted, setIsStarted] = useState(false);
  const handleStart = () => {};
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState('');
  const handleInputChange = (_, value) => {
    setInput(value);
  };
  const sendOutgoingMessage = () => {};
  const sendIncomingMessage = () => {};
  const handleSend = () => {
    let value = input;
    const outgoing = createMessage(value, { type: 'outgoing' });
    setInput('');
    sendOutgoingMessage({ message: outgoing });
    sendIncomingMessage({});
  };
  return (
    <Grid item xs={12} sx={isSm&&{height:"100%"}}>
      <MainContainer responsive style={{ borderRadius: variants.boxRadius.MAIN, position: 'relative' }}>
        <ChatContainer style={{ paddingTop: '1rem', height: '90vh' }}>
          <MessageList typingIndicator={<TypingIndicator content='GG bot is under development' />}>
            <Message
              model={{
                direction: 'incoming',
                position: 'single',
              }}
            >
              <Avatar
                style={{
                  border: '2px solid #03a9f4',
                }}
                src={GGbotGIF}
              />
              <Message.CustomContent>
                <Typography sx={{ fontSize: variants.BODY }}>
                  Welcome to GGbot, your Gateway Group Bot! I'm here to assist you with any questions, provide
                  information, and help you navigate through our services. Whether you need support, want to learn more
                  about what we offer, or just have a general inquiry, GGbot is at your service. Let's get started and
                  make your experience with Gateway Group seamless and efficient!
                </Typography>
              </Message.CustomContent>
            </Message>

            <Message
              style={{ marginTop: '1rem' }}
              model={{
                direction: 'incoming',
                position: 'single',
              }}
            >
              <Avatar
                style={{
                  border: '2px solid #03a9f4',
                }}
                src={GGbotGIF}
              />
              <Message.CustomContent>
                <Stack direction={'row'}>
                  <Typography sx={{ fontSize: variants.BODY, mr: 1 }}>
                    This bot is under development, this feature will be available soon.
                  </Typography>
                  <img src={rocket} style={{ width: 25, height: 25 }} />
                </Stack>
              </Message.CustomContent>
            </Message>
          </MessageList>

          <MessageInput
            autoFocus
            placeholder='Type message here'
            onChange={handleInputChange}
            onSend={handleSend}
            value={input}
            attachButton={false}
          />
        </ChatContainer>
      </MainContainer>
    </Grid>
  );
};

export default GGBotChat;
